import { Button, Grid, Tooltip, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { Await, useLocation, useNavigate, useParams } from 'react-router-dom';
import { workOrdersApiKeyStore } from '../../../api/workorders-api-key-store';
import { FormInput } from '../../../components/hook-form/form-input.component';
import { ReactHookForm } from '../../../components/hook-form/react-hook-form.component';
import { SiTrackPage } from '../../../components/si-track-page';
import { useLoadData } from '../../../hooks/useLoadData';
import { useReactHookForm } from '../../../hooks/useReactHookForm';
import { ApiResponse } from '../../../models/api-response';
import { WorkOrder } from '../../../models/workOrder';
import { FormButtons } from '../../customers/create-customer/form-buttons.component';
import { NotesDialog } from '../../note/notes.dialog';
import { PurchaseOrderDialog } from '../workorders-tab/puchase-order.dialog';
import { WorkOrderStatusButtons } from '../workorders-tab/status-buttons.component';
import EditIcon from '@mui/icons-material/Edit';

import { DateFormat, FormDateField } from '../../../components/hook-form/form-date.field.component';
import { useSaveData, useSaveDataForQuickBook } from '../../../hooks/useSaveData';
import { ScheduleDialog } from '../workorders-tab/shedule.dialog';
import { Icons } from '../../../assets/icons';
import { FormSelect } from '../../../components/hook-form/form-select.component';
import { useFileDownload } from '../../../components/file-download';
import { WorkorderDocumentDialog } from '../workorder-document/workorder-document.dialog';
import EditWorkOrderForm from './edit-work-order-form';
import { number } from 'yup';
import { UserPermissionName } from '../../../models/user-permission-name';
import { GuardedComponent } from '../../../components/guarded-component';
import ConfirmDialog from '../../../components/confirm-dialog';
import { SelectServiceDialog } from './switch-service/select-service-switch-service';
import { useAuthorize } from '../../../hooks/use-authorize';

const styling = {
  labelStyle: { color: '#707070', fontSize: '14px', fontWeight: '600' },
  valueStyle: { color: '#000', fontWeight: '500', fontSize: '13px' },
  buttonStyle: { width: '130px' },
};

interface HeaderValueCellProps {
  workOrder?: any;
  heading: string;
  value: any;
  isRequired?: boolean;
  fileType?: string;
  className?: string;
  reloadData?: any;
  handleOpenPurchaseOrderDialog?: () => void;
  handleDownloadClick?: () => void;
}

const EditWorkOrder = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [noteTempEntityID, setNoteTempEntityID] = useState<number>();
  const [openNoteDialog, setOpenNoteDialog] = useState(false);
  const [openServiceDialog, setOpenServiceDialog] = useState(false);
  const [openPurchaseOrder, setOpenPurchaseOrder] = useState(false);
  const [openWODocumentDialog, setOpenWODocumentDialog] = useState(false);
  const [selectedServiceID, setSelectedServiceID] = useState<number>(0);
  const [isConfirmation, setIsConfirmation] = useState<boolean>(false);
  const { isLoading, data, refetch } = useLoadData<ApiResponse<WorkOrder>>(
    workOrdersApiKeyStore.getWorkorderDetails(Number(id))
  );
  const { isLoading: saveWorkordeLoading, mutateAsync } = useSaveData<any>(workOrdersApiKeyStore.updateWorkOrder());

  const formData = data?.data || {};
  const form = useReactHookForm({
    defaultValues: {
      invoiceTerm: '',
      workedHours: '',
      billingAgainst: '',
      permitType: '',
      inspectionReportUploaded: '',
      feeWaived: '',
      isActive:''
    },
  });
  const watchValue = form.watch();
  const { isLoading: isLoadingQickbookCall, mutateAsync: quickBookCall } = useSaveDataForQuickBook(
    workOrdersApiKeyStore.QUICBOOK_INVOICE_REPORT()
  );

  const location = useLocation();
  const pageForm = location.state?.page;

  const { error, downloadFile } = useFileDownload();
  // useEffect(() => {
  //   if (formData) {
  //     form.reset(formData); // Reset the form with new data
  //   }
  // }, [formData]);

  const handleOpenNoteDialog = () => {
    setOpenNoteDialog(true);
  };

  const handleOpenPurchaseOrderDialog = () => {
    setOpenPurchaseOrder(true);
  };
  const handleClosePurchaseOrderDialog = () => {
    setOpenPurchaseOrder(false);
  };

  const handleOpenServiceDialog = () => {
    setOpenServiceDialog(true);
  };
  const handleCloseServiceDialog = () => {
    setOpenServiceDialog(false);
  };

  const handleCloseNoteDialog = (tempNoteEntityID?: number) => {
    setOpenNoteDialog(false);
    if (tempNoteEntityID) {
      setNoteTempEntityID(tempNoteEntityID);
    }
  };

  const hanldeSelectServiceId = (value: number) => {
    setSelectedServiceID(value);
  };
  const handleSubmit = async (dataValue: any) => {
    if (pageForm && data?.data?.invoiceAmount !== dataValue?.invoiceAmount) {
      setIsConfirmation(true);
    } else {
      const workorderData = {
        workOrderID: data?.data?.workOrderID,
        forecastedDate: dataValue?.forecastedDate,
        invoiceTerm: !data?.data?.isHourlyorTimeMaterialService ? null : dataValue?.invoiceTerm,
        workedHours: !data?.data?.isHourlyorTimeMaterialService ? null : dataValue?.workedHours,
        billingAgainst: dataValue?.billingAgainst,
        permitType: dataValue?.permitType?.permitType,
        invoiceAmount: dataValue?.invoiceAmount,
        feeWaived: dataValue?.feeWaived ?? false,
        inspectionReportUploaded: dataValue?.inspectionReportUploaded ?? false,
        isActive: dataValue?.isActive ?? false,
      };
      await mutateAsync({ data: workorderData });
      refetch();
    }
  };

  const handleDownloadClick = () => {
    // const data = { ...data?.data, workOrderID: data?.data?.workOrderID, fileType: data?.data?.fileType };
    downloadFile({ additionalData: data?.data });
  };

  const handleOpenWODocumentDialog = () => {
    setOpenWODocumentDialog(!openWODocumentDialog);
  };

  const handleClose = () => {
    setIsConfirmation(false);
  };

  const handleConfirm = async () => {
    const dataValue = watchValue;
    const qbData = {
      InvoiceAmount: !dataValue?.invoiceAmount ? 0 : Number(dataValue?.invoiceAmount),
      qBOInvoiceID: data?.data?.qboInvoiceID,
      workOrderID: Number(id),
    };

    quickBookCall({ data: qbData }).then(async () => {
      const workorderData = {
        workOrderID: data?.data?.workOrderID,
        forecastedDate: dataValue?.forecastedDate,
        invoiceTerm: !data?.data?.isHourlyorTimeMaterialService ? null : dataValue?.invoiceTerm,
        workedHours: !data?.data?.isHourlyorTimeMaterialService ? null : dataValue?.workedHours,
        billingAgainst: dataValue?.billingAgainst,
        permitType: dataValue?.permitType?.permitType,
        invoiceAmount: dataValue?.invoiceAmount,
        feeWaived: dataValue?.feeWaived ?? false,
        inspectionReportUploaded: dataValue?.inspectionReportUploaded ?? false,
        isActive: dataValue?.isActive ?? false,
      };
      await mutateAsync({ data: workorderData });
      refetch();
    });

    setIsConfirmation(false);
  };

  const isReadOnlyPermission = useAuthorize([UserPermissionName?.READ_ONLY]);

  return (
    <SiTrackPage title="Edit Workorder" isLoading={isLoading}>
      <GuardedComponent requiredPermissions={[UserPermissionName.UPDATE_STATUS_WORKORDER]}>
        <div className="d-flex " style={{ justifyContent: 'flex-end' }}>
          {/* <WorkOrderStatusButtons workOrder={data?.data} reloadData={refetch} /> */}

          {!data?.data.isUnitCompleted ? (
            <WorkOrderStatusButtons workOrder={data?.data} reloadData={refetch} />
          ) : (
            <span style={{ color: 'red' }}>Lot/Unit is completed</span>
          )}
        </div>
      </GuardedComponent>
      <ReactHookForm formName="EDIT_CUSTOMER_FORM" onSubmit={handleSubmit} formContextProps={form}>
        {data?.data && (
          <EditWorkOrderForm
            data={data?.data}
            onHandleDownloadClick={handleDownloadClick}
            onHandleOpenNoteDialog={handleOpenNoteDialog}
            onHandleOpenPurchaseOrderDialog={handleOpenPurchaseOrderDialog}
            onHandleOpenServiceDialog={handleOpenServiceDialog}
            onHandleOpenWODocumentDialog={handleOpenWODocumentDialog}
            refetch={refetch}
          />
        )}

        <Grid item lg={12} sm={12} xl={12} xs={12} spacing={1}>
          <Grid container justifyContent="space-between" spacing={1}>
            <Grid item>
              <Button variant="outlined" style={styling.buttonStyle} onClick={() => navigate(`/workorders`)}>
                Cancel
              </Button>
            </Grid>
            <Grid item>
              <Button
                type={'submit'}
                disabled={isLoading || saveWorkordeLoading || !data?.data?.canEdit || isReadOnlyPermission}
                variant="contained"
                disableElevation={true}
                style={styling.buttonStyle}
              >
                Save
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </ReactHookForm>
      {openNoteDialog && (
        <NotesDialog
          title="PROJECT"
          noteRequestArgs={{ ...(data?.data ? { workOrderID: data?.data?.workOrderID } : { noteTempEntityID }) }}
          open={openNoteDialog}
          onClose={handleCloseNoteDialog}
        />
      )}
      {openWODocumentDialog && (
        <WorkorderDocumentDialog
          open={openWODocumentDialog}
          documentRequestArgs={{ workOrderID: Number(id), workOrderNumber: data?.data?.workOrderNumber }}
          onClose={handleOpenWODocumentDialog}
        />
      )}
      {openPurchaseOrder && (
        <PurchaseOrderDialog
          title="PURCHASE ORDER"
          workOrderData={data && data?.data}
          workOrderID={!data?.data?.workOrderID ? 0 : data?.data?.workOrderID}
          open={openPurchaseOrder}
          onClose={handleClosePurchaseOrderDialog}
          reloadData={refetch}
        />
      )}

      {isConfirmation && (
        <ConfirmDialog
          message="The changed invoice amount will be updated in QuickBooks invoice. Are you sure you want to continue?"
          onClose={handleClose}
          onConfirm={handleConfirm}
          open={isConfirmation}
        />
      )}
      <SelectServiceDialog
        onClose={handleCloseServiceDialog}
        open={openServiceDialog}
        unitID={!data?.data?.unitID ? 0 : data?.data?.unitID}
        workOrderID={!data?.data?.workOrderID ? 0 : data?.data?.workOrderID}
        onHandleSetSelectedServiceId={hanldeSelectServiceId}
        selectedServiceID={selectedServiceID}
        refetch={refetch}
      />
    </SiTrackPage>
  );
};

export default EditWorkOrder;
